export const GET_RESTRICTIONS_QUERY_KEY = 'life_events_restrictions';
